import { render, staticRenderFns } from "./JuegosFqa.vue?vue&type=template&id=06ef7508&scoped=true"
import script from "./JuegosFqa.vue?vue&type=script&lang=js"
export * from "./JuegosFqa.vue?vue&type=script&lang=js"
import style0 from "./JuegosFqa.vue?vue&type=style&index=0&id=06ef7508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ef7508",
  null
  
)

export default component.exports